import React from 'react'

export default (props) => (
  <div>
    <h2>Home</h2>
    <h3>ID: {props.match.path}</h3>
    {/*{console.log('hi:::: --- ', props)}*/}
  </div>
)


// WEBPACK FOOTER //
// ./src/components/pages/Home.js